import React from 'react';
import { useTranslation } from 'react-i18next';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import useStyles from './styles';

const PriceDetails = ({ priceDetails, classes, isRelated }) => {
  
  const [t] = useTranslation();

  return (
    <AccordionDetails classes={{ root: classes.panelDetailsRoot }}>
      {isRelated && priceDetails.type === 'activity' && (
        <div className={classes.column}>
          <ListSubheader className={classes.summarySubheader}>
            {t('Activities')}
          </ListSubheader>
          <Typography className={classes.unitTitle}>
            {priceDetails.title}
          </Typography>
        </div>
      )}
      {isRelated && priceDetails.type === 'accommodation' && (
        <div className={classes.column}>
          <ListSubheader className={classes.summarySubheader}>
            {t('Accommodation')}
          </ListSubheader>
          <Typography className={classes.unitTitle}>
            {priceDetails.title}
          </Typography>
        </div>
      )}
      {priceDetails.guestsTotal &&
        priceDetails.guestsTotal.map((guest, index) => {
          return (
            <ListItem key={index} className={classes.listItem}>
              <div className={classes.priceDetails}>
                <Typography className={classes.currency}>
                  {priceDetails.currency}
                </Typography>
                <Typography style={{ fontWeight: 'bold', padding: '0px 5px' }}>
                  {`${guest.guestPrice}`}
                </Typography>
                {guest && guest.participant && (
                  <Typography>
                    x {guest.count} {t(guest.participant)}
                  </Typography>
                )}
                {guest && guest.participant === '' && (
                  <Typography>
                    x {guest.count}{' '}
                    <span style={{ textTransform: 'lowercase' }}>
                      {t('Guests')}
                    </span>
                  </Typography>
                )}
                {priceDetails.nightsNumber && (
                  <Typography style={{ paddingLeft: '5px' }}>
                    x {priceDetails.nightsNumber}{' '}
                    {priceDetails.nightsNumber > 1 ? t('nights') : t('night')}
                  </Typography>
                )}
              </div>
              <Typography
                className={classes.currency}
                style={{ paddingLeft: '30px' }}
              >
                {priceDetails.currency}
              </Typography>
              <Typography style={{ paddingLeft: '5px', fontWeight: 'bold' }}>
                {guest.total}
              </Typography>
            </ListItem>
          );
        })}

      {priceDetails?.type === 'Rental Items' && (
        <>
          <ListSubheader className={classes.summarySubheader}>
            {t('Rental Details')}
          </ListSubheader>

          <ListItem className={classes.listItem}>
            <div className={classes.priceDetails}>
              <Typography
                className={classes.total}
              ></Typography>
              <Typography>{priceDetails.title}</Typography>
            </div>
            <Typography
              className={classes.currency}
              style={{ paddingLeft: '30px' }}
            >
              {priceDetails.currency}
            </Typography>
            <Typography
              className={classes.total}
              style={{ paddingLeft: '5px' }}
            >
              {priceDetails.unitsTotal}
            </Typography>
          </ListItem>

          <ListItem className={classes.listItem}>
            <Typography>
              {t('Days')} {priceDetails.daysNumber} {t('- Units')}{' '}
              {priceDetails.unitsNumber}
            </Typography>
          </ListItem>
        </>
      )}

      {priceDetails.addOnsTotal.length !== 0 && (
        <ListSubheader className={classes.summarySubheader}>
          {t('Add-ons')}
        </ListSubheader>
      )}
      {priceDetails.addOnsTotal.length !== 0 &&
        priceDetails.addOnsTotal.map((addOn, index) => {
          return (
            <ListItem key={index} className={classes.listItem}>
              <div className={classes.priceDetails}>
                <Typography className={classes.currency}>
                  {priceDetails.currency}
                </Typography>
                <Typography
                  className={classes.total}
                  style={{ padding: '0px 5px' }}
                >
                  {`${addOn.addOnPrice}`}
                </Typography>
                <Typography>
                  x {addOn.count} {addOn.title}
                </Typography>
              </div>
              <Typography
                className={classes.currency}
                style={{ paddingLeft: '30px' }}
              >
                {priceDetails.currency}
              </Typography>
              <Typography
                className={classes.total}
                style={{ paddingLeft: '5px' }}
              >
                {addOn.total}
              </Typography>
            </ListItem>
          );
        })}

      {priceDetails?.type === 'accommodation' &&
        Array.isArray(priceDetails?.mandatoryFeesTotal) &&
        priceDetails.mandatoryFeesTotal.length !== 0 && (
          <ListSubheader className={classes.summarySubheader}>
            {t('Mandatory-Fees')}
          </ListSubheader>
        )}

      {priceDetails?.type === 'accommodation' &&
        Array.isArray(priceDetails?.mandatoryFeesTotal) &&
        priceDetails.mandatoryFeesTotal.length !== 0 &&
        priceDetails.mandatoryFeesTotal.map((mandatoryFee, index) => (
          <ListItem key={index} className={classes.listItem}>
            <div className={classes.priceDetails}>
              <Typography className={classes.currency}>
                {priceDetails.currency}
              </Typography>
              <Typography
                className={classes.total}
                style={{ padding: '0px 5px' }}
              ></Typography>
              <Typography>{mandatoryFee.title}</Typography>
            </div>
            <Typography
              className={classes.currency}
              style={{ paddingLeft: '30px' }}
            >
              {priceDetails.currency}
            </Typography>
            <Typography
              className={classes.total}
              style={{ paddingLeft: '5px' }}
            >
              {mandatoryFee.total}
            </Typography>
          </ListItem>
        ))}
    </AccordionDetails>
  );
};

const BookingPriceDetailsPanel = ({ priceDetails }) => {
  const classes = useStyles();
  const [t] = useTranslation();
  const [expanded, setExpanded] = React.useState(false);  

  const relatedBookings =
    priceDetails.relatedBookings ||
    priceDetails.relatedActivitiesBookings ||
    [];

  return (
    <div className={classes.root}>
      <Accordion
        elevation={0}
        expanded={expanded}
        onChange={(event, isExpanded) => setExpanded(isExpanded)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          classes={{ root: classes.panel }}
          aria-controls="panel1c-content"
          id="panel1c-header"
        >
          <div className={classes.column}>
            <Typography className={classes.heading}>
              {t('Booking summary')}
            </Typography>
            {!expanded && (
              <div className={classes.subheader}>
                <Typography className={classes.currency}>
                  {priceDetails.currency}
                </Typography>
                <Typography
                  style={{ paddingLeft: '5px' }}
                  className={classes.total}
                >
                  {priceDetails.total}
                </Typography>
              </div>
            )}
          </div>
        </AccordionSummary>
        <PriceDetails priceDetails={priceDetails} classes={classes} />
        {relatedBookings &&
          relatedBookings.map((booking, index) => {
            return (
              <PriceDetails
                key={index}
                priceDetails={booking}
                classes={classes}
                isRelated={true}
              />
            );
          })}
        <ListItem
          style={{ backgroundColor: '#E2F5F8', paddingTop: 0 }}
          className={classes.listItem}
        >
          <div className={classes.totalContainer}>
            <Typography className={classes.total}>{t('Total')}</Typography>
          </div>
          <div className={classes.totalPriceContainer}>
            <Typography className={classes.currency}>
              {priceDetails.currency}
            </Typography>
            <Typography
              style={{ paddingLeft: '5px' }}
              className={classes.total}
            >
              {priceDetails.total}
            </Typography>
          </div>
        </ListItem>
      </Accordion>
    </div>
  );
};
export default BookingPriceDetailsPanel;
